export const email = () => {
  return (
    <svg
      width="28"
      height="26"
      viewBox="0 0 28 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.7669 3.31053C3.21955 3.31053 2.56834 3.84672 2.56834 4.74902V21.085C2.56834 21.9873 3.21955 22.5235 3.7669 22.5235H23.6288C24.1761 22.5235 24.8273 21.9873 24.8273 21.085V4.74902C24.8273 3.84672 24.1761 3.31053 23.6288 3.31053H3.7669ZM0 4.74902C0 2.65639 1.58325 0.742188 3.7669 0.742188H23.6288C25.8124 0.742188 27.3957 2.65639 27.3957 4.74902V21.085C27.3957 23.1776 25.8124 25.0918 23.6288 25.0918H3.7669C1.58325 25.0918 0 23.1776 0 21.085V4.74902Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.265591 3.96749C0.697454 3.40491 1.50361 3.29894 2.06619 3.7308L13.6979 12.6598L25.3296 3.7308C25.8922 3.29894 26.6983 3.40491 27.1302 3.96749C27.5621 4.53007 27.4561 5.33623 26.8935 5.76809L14.4798 15.2974C14.0187 15.6514 13.3771 15.6514 12.9159 15.2974L0.502279 5.76809C-0.0603036 5.33623 -0.166272 4.53007 0.265591 3.96749Z"
      />
    </svg>
  )
}
